import { AngularDirective } from '~src/common/react/components/AngularDirective';
import { ILoginScope } from '~src/ts/controllers/LoginCtrl';
import { RootLoginUiProps } from './RootLoginUi';
import React = require('react');

const template = `<div ng-controller="LoginCtrl" ng-include="'login.html'"></div>`;

export function LegacyLoginController(props: RootLoginUiProps) {

    function setupScope(scope: ng.IScope) {
        const childScope = scope.$new() as ILoginScope;
        childScope.signinQueryParams = props.signinQueryParams;
        return childScope;
    }

    return <AngularDirective
        template={template}
        angularContext={props.angularContext}
        setupScope={setupScope}
    />;
}
